import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';

export const useRealTime = () => {
  const [now, setNow] = useState(moment());
  const isInCurrentHour = useCallback((hour: number) => now.hour() - hour === 0, [now]);

  useEffect(() => {
    setInterval(() => {
      setNow(moment());
    }, 1000);
  }, []);

  return {
    isInCurrentHour,
    now,
  };
};
